import { AxiosResponse } from "axios";
import axiosInstance from "../../../../interceptors/axiosInstance";
import { ListResponseDto } from "../../../../dtos/ListResponseDto";
import { RecaudacionDiariaReportDto } from "../models/recaudacionDiara";

const getRecaudacionDiaria = async (fechaInicio: Date, fechaFin: Date, usuario: string) => {
    const response: AxiosResponse<ListResponseDto<RecaudacionDiariaReportDto>> = await axiosInstance.get('siscred-api-recaudacion/v1/recaudacion/obtener-recaudacion-diaria', {
        params: {
            fechaInicio,
            fechaFin,
            usuario
        },
    });
    return response;
};

export {
    getRecaudacionDiaria
};
